/*
    App Constants
 */

export const DEPOSIT_LISTING_DISPLAY_MODE_ALL_DEPOSITS = 'ALL_DEPOSITS';
export const DEPOSIT_LISTING_DISPLAY_MODE_SEARCH_RESULTS = 'SEARCH_RESULTS';

export const DIALOG_MODE_CANCEL = 'cancel';
export const DIALOG_MODE_ARCHIVE = 'archive';